var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/notifications/components/setting-toggle.tsx";
import React from 'react';
import { Toggle } from 'soapbox/components/ui';

/** Stateful toggle to change user settings. */
const SettingToggle = _ref => {
  let {
    id,
    settings,
    settingPath,
    onChange
  } = _ref;

  const handleChange = _ref2 => {
    let {
      target
    } = _ref2;
    onChange(settingPath, target.checked);
  };

  return /*#__PURE__*/React.createElement(Toggle, {
    id: id,
    checked: !!settings.getIn(settingPath),
    onChange: handleChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 5
    }
  });
};

export default SettingToggle;